import React from "react";

const Stat_Inference = () => {
  return (
    <div>
      <h1>Stat Inference</h1>
    </div>
  );
};

export default Stat_Inference;
